import axios from "axios";
import { jwtDecode } from "jwt-decode";

const api = axios.create({
  //baseURL: "https://sivempc.veracruz.gob.mx/api",
  baseURL: "https://sidec.veracruz.gob.mx/api",
});

const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

api.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));

  const token =
    user?.token ||
    localStorage.getItem("jwt");

  if (token) {
    if (isTokenExpired(token)) {
      localStorage.removeItem("user");
      localStorage.removeItem("jwt");
      window.location.href = "/login";
      return Promise.reject(new Error("Token expirado"));
    }

    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;